'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _eventStack = require('./eventStack');

var _eventStack2 = _interopRequireDefault(_eventStack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _eventStack2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/dist/commonjs/lib/eventStack/index.js
 ** module id = 3878
 ** module chunks = 0
 **/